import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Globals } from './globals';

@Injectable()
export class loggedInAccess {
    constructor(public router: Router, public globals: Globals, private toastr: ToastrService) { }

    canActivate(route: ActivatedRouteSnapshot) {
        this.globals.loadUserInfo();
        if (this.globals.loggedIn) {

            // Check user session start
            if (new Date().getTime() - this.globals.currentUserInfo.sessionTime >= this.globals.sessionExpireTime) {
                this.globals.loggedIn = false;
                localStorage.clear();
                this.toastr.warning("Please signin first to view the content");
                this.router.navigate(['/login'], { replaceUrl: true });
                return false;
            }
            this.globals.currentUserInfo.sessionTime = new Date().getTime();
            localStorage.setItem(this.globals.UID, JSON.stringify(this.globals.currentUserInfo));
            // Check user session end

            //return true;
            let pagePermissions = route.data.permission;
            let canAccess = false;
            if (typeof pagePermissions != "undefined" && pagePermissions.length > 0) {
                for (var permission of pagePermissions) {
                    if (this.globals.checkUserHasPermission(permission) == true) {
                        canAccess = true;
                        break;
                    } else {
                        canAccess = false;
                        break;
                    }
                }
                if (!canAccess) {
                    this.router.navigate(['/']);
                }
                return canAccess;

            } else {
                return true;
            }
        }
        else {
            this.toastr.warning("Please signin first to view the content");
            this.router.navigate(['/login'], { replaceUrl: true });
            return false;
        }

    }
}